export default ({
  isFirstLoading: true,
  fetching: {
    getCoreLines: false,
    saveCoreLine: false,
  },
  api: {
    coreLines: [],
  }
});